import React from 'react';
import Styled from 'styled-components';
import propTypes from 'prop-types';

const StyledApplet = Styled.div`
width: 400px;
height: 100%;
background: #FFFFFF;
border: 1px solid black;
border-radius: 12px;
margin-left: auto;
margin-right: auto;
margin-top: 50px;
padding: 12px;

`;

export const AppletContainer = Styled.div`
  margin-left: auto;
  margin-right: auto;


  
`;

const Applet = ({ children, width, height, showBorder }) => (
    <StyledApplet
        style={{ boxShadow: showBorder ? ' 0px 1px 2px #00000059' : 'unset' }}
        height={height}
        width={width}
    >
        {children}
    </StyledApplet>
);

Applet.propTypes = {
    children: propTypes.node.isRequired,
    width: propTypes.string,
    height: propTypes.string,
    showBorder: propTypes.bool,
};

Applet.defaultProps = {
    width: '352px',
    height: '335px',
    showBorder: true,
};
export default Applet;
